// extracted by mini-css-extract-plugin
export default {"root":"burgerDescription_root__H8yeF","description":"burgerDescription_description__JCMgE","close":"burgerDescription_close__Esirw"};